export default "/images/vendor/flag-icons/flags/4x3/mz.svg?22cb086638f1a52c4e49f57662f7b9d5";